import cookie from 'js-cookie';
import { get } from 'lodash';
import VueI18n from 'vue-i18n';
import messages from '../../i18n/i18n';
import {
  ZoomWorkplaceRebrandingReg,
  ZOOM_WORKPLACE,
  zoomSessionsRebrandingReg,
  ZOOM_WEBINARS_PLUS,
  dynamicTranslation4Rebranding,
} from '@zoom/billing-rebranding';

const locale = cookie.get('_zm_lang') || 'en-US';

let _i18n = null;

export function translation(i18nKey, params = []) {
  if (!_i18n) {
    _i18n = new VueI18n({
      locale,
      messages,
    });
  }
  return _i18n.t(i18nKey, params);
}

function findPath(obj, value, currentPath = []) {
  for (let key in obj) {
    if (obj[key] === value) {
      return [...currentPath, key];
    } else if (typeof obj[key] === 'object') {
      const result = findPath(obj[key], value, [...currentPath, key]);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

export function translationText4Rebranding(originalText) {
  if (isRebranding) {
    return originalText.replace(ZoomWorkplaceRebrandingReg, ZOOM_WORKPLACE);
  }
  if (sessionToWebinarPlusRename) {
    return originalText.replace(zoomSessionsRebrandingReg, ZOOM_WEBINARS_PLUS);
  }
  return originalText;
}

export function translateToEn(key, args = []) {
  let result = get(messages, `en-US.${key}`, key)
  if (typeof result !== 'string') {
    console.error('Invalid key, requires String type')
    return ''
  }
  args.forEach((arg, idx) => {
    result = result.replace(new RegExp(`\\{${idx}\\}`, 'g'), arg)
  })
  return translationText4Rebranding(result);
}

export function translateToEnByMessage(message) {
  if (!message) {
    return null;
  }
  const mPath = findPath(messages[locale], message);
  if (!mPath) {
    return null;
  }
  let result = translateToEn(mPath.join('.'));

  return translationText4Rebranding(result);
}

const rebrandingVar1 = window?.dataModel?.zoomWorkplaceRebranding === 'Workplace'

const rebrandingVar2 = window.newBillingConfig?.enableZoomWorkPlaceRebranding

const isRebranding = window?.newBillingConfig?.isZoomWorkplaceRebranding || rebrandingVar1 || rebrandingVar2

export const sessionToWebinarPlusRename =
  get(window, 'newBillingConfig.sessionToWebinarPlusRename', false) ||
  get(window, 'dataModel.sessionToWebinarPlusRename', false) ||
  get(window, 'dataModel.sessionsRenaming', false);

export const t = dynamicTranslation4Rebranding(translation, { isZoomWorkplaceRebranding: isRebranding, sessionToWebinarPlusRename });

const zmLang = window._zm_lang;

const hreflangJson = [
  {"id":"en", "code":"en-US"},
  {"id":"es", "code":"es-ES"},
  {"id":"de", "code":"de-DE"},
  {"id":"zh-cn", "code":"zh-CN"},
  {"id":"zh-tw", "code":"zh-TW"},
  {"id":"fr", "code":"fr-FR"},
  {"id":"pt", "code":"pt-PT"},
  {"id":"ja", "code":"jp-JP"},
  {"id":"ru", "code":"ru-RU"},
  {"id":"ko", "code":"ko-KO"},
  {"id":"it", "code":"it-IT"},
  {"id":"vi", "code":"vi-VN"},
  {"id":"pl", "code":"pl-PL"},
  {"id":"tr", "code":"tr-TR"},
  {"id":"id", "code":"id-ID"},
  {"id":"nl", "code":"nl-NL"},
  {"id":"sv", "code":"sv-SE"}
];

const langCookie = zmLang || cookie.get('_zm_lang') || 'en-US';

export function getHreflang() {
  let hreflang = 'en';

  hreflangJson.forEach(function (jsonEle) {
    if (jsonEle.code === langCookie) {
      hreflang = jsonEle.id;
    }
  });

  return hreflang;
}
